import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Sampaio Dental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'dentistcapecoralSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: true,
  enablePlanCardConfig: true,
  headerProps: {
    enable: true,
  },
  localeProps: {
    enable: true,
    localesList: [
      {
        key: 'en',
        value: 'English',
      },
      {
        key: 'es',
        value: 'Español',
      },
    ],
  },
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      alignContent: 'center',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'contained',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'left',
      alignCard: 'center',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit: 4,
      cardVariant: 1,
      regularCardVariant: 1,
      hybridPlanCardConfig: true,
      regularPlanCount: 3,
      tabVariant: 1,
      disableGroupSavings: true,
      maxPlansPerSlide: 4,
      plansPerRow: { xs: 1, sm: 1, md: 1, lg: 3 },
      carouselResponsiveItems: {
        superLargeDesktop: 3,
        desktop: 3,
        tablet: 1,
        mobile: 1,
      },
      showAddons: true,
      addonProps: {
        addonVariant: 2,
      },
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        usePrimaryPillForAll: true,
        buttonProps: {
          customSpace: 11,
          normalVariant: 'outlined',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
      },
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        customSpace: 12,
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'outlined',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    allowLocale: true,
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  faqSection: {
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
